import League from "../../entities/League.js";

const baseballLeague = function(league) {
    return (league instanceof League) && league.sportType === 'Baseball';
};

export default baseballLeague;